import React, { useState, useEffect, useCallback } from "react";
import moment from "moment";
import { connect } from "react-redux";

import TransfersFilters from "../TransfersFilters";
import { getTransfersDetails } from "../../actions/transfers";
import { Pagination } from "antd";

const columns = ["Nom", "Société", "Référence", "Date création", "Date de dernière mise à jour", "Montant", "Statut"];

const TransfersDetails = ({ getTransfersDetails, transfersDetailsList = [], token, userRoleId }) => {
  const [dateSelected, setSelectedDate] = useState();
  const [selectedUserName, setSelectedUserName] = useState();
  const [selectedBankStatus, setSelectedBankStatus] = useState();
  const [selectedCompanyLabel, setSelectedCompanyLabel] = useState();
  const [selectedTransferId, setSelectedTransferId] = useState();
  const [currentPage, setCurrentPage] = useState(1);

  const getRequestParams = () => {
    const filters = {
      match: {},
      page: 1
    };

    if (selectedCompanyLabel) filters.match["user_company_label"] = selectedCompanyLabel;
    if (selectedBankStatus) filters.match["transfer.status.label"] = selectedBankStatus;
    if (selectedTransferId) filters.match["transfer.id"] = selectedTransferId;
    if (selectedUserName) filters.match["user_fullname"] = selectedUserName;
    if (dateSelected) {
      filters.match["created_at"] = {
        $gte: { $date: moment(dateSelected).startOf("day") },
        $lte: { $date: moment(dateSelected).endOf("day") }
      };
    }
    return filters;
  };

  const requestFetchTransfersDetails = useCallback(
    (
      params = {
        match: {},
        page: currentPage
      }
    ) => {
      getTransfersDetails(params);
    },
    [getTransfersDetails]
  );

  useEffect(() => {
    requestFetchTransfersDetails();
  }, []);

  useEffect(() => {
    requestFetchTransfersDetails({
      ...getRequestParams()
    });
  }, [selectedCompanyLabel, selectedBankStatus, selectedUserName, selectedTransferId, dateSelected]);

  const onChangeListPage = value => {
    setCurrentPage(value);
    requestFetchTransfersDetails({
      page: value,
      match: {
        ...getRequestParams().match
      }
    });
  };

  const getStatusStyle = statusId => {
    if (statusId === 1) return "text-gray-400";
    else if (statusId === 2) return "text-green-400";
    return "text-red-500";
  };

  const getTransfersDetailsList = () => (transfersDetailsList ? transfersDetailsList.docs : []);

  return (
    <div>
      <TransfersFilters
        token={token}
        userRoleId={userRoleId}
        dateSelected={dateSelected}
        selectedUserName={selectedUserName}
        setSelectedDate={setSelectedDate}
        setSelectedUserName={setSelectedUserName}
        setSelectedBankStatus={setSelectedBankStatus}
        selectedBankStatus={selectedBankStatus}
        selectedCompanyLabel={selectedCompanyLabel}
        setSelectedCompanyLabel={setSelectedCompanyLabel}
        selectedTransferId={selectedTransferId}
        setSelectedTransferId={setSelectedTransferId}
        data={getTransfersDetailsList()}
        menuItem="details"
      />
      <table className="min-w-full">
        <thead>
          <tr>
            {columns.map(columnTitle => (
              <th
                index={columnTitle}
                className="px-6 py-3 border-b border-gray-200 text-left leading-4 font-medium text-gray-800 tracking-wider"
              >
                {columnTitle}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white">
          {transfersDetailsList &&
            transfersDetailsList.docs &&
            getTransfersDetailsList().map(dataItem => {
              return (
                <tr className="hover:bg-gray-100 cursor-pointer">
                  <td className="w-1/6 p-6 whitespace-no-wrap border-b border-gray-200 text-md leading-5 text-gray-900">
                    {dataItem.user_fullname}
                  </td>
                  <td className="w-1/12 p-6 whitespace-no-wrap border-b border-gray-200 text-md leading-5 text-gray-900">
                    {dataItem.user_company_label}
                  </td>
                  <td className="w-1/12 p-6 whitespace-no-wrap border-b border-gray-200 text-md leading-5 text-gray-900">
                    {dataItem.transfer.id}
                  </td>
                  <td className="w-1/12 p-6 whitespace-no-wrap border-b border-gray-200 text-md leading-5 text-gray-900">
                    {moment(dataItem.created_at).format("DD/MM/YYYY")}
                  </td>
                  <td className="w-1/12 p-6 whitespace-no-wrap border-b border-gray-200 text-md leading-5 text-gray-900">
                    {moment(dataItem.updated_at).format("DD/MM/YYYY")}
                  </td>
                  <td className="w-1/12 p-6 whitespace-no-wrap border-b border-gray-200 text-md leading-5 text-gray-900">
                    {dataItem.amount && Number.parseFloat(dataItem.amount).toFixed(2)} €
                  </td>
                  <td className="w-1/12 p-6 whitespace-no-wrap border-b border-gray-200 text-md leading-5 text-gray-900">
                    {dataItem.transfer && dataItem.transfer.status && (
                      <div className={`font-bold ${getStatusStyle(dataItem.transfer.status.id)}`}>
                        {dataItem.transfer.status.label}
                      </div>
                    )}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
      {transfersDetailsList && (
        <div className="flex justify-end mt-8">
          <Pagination
            defaultCurrent={transfersDetailsList.page}
            total={transfersDetailsList.total}
            onChange={onChangeListPage}
          />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    token: state.auth.token,
    userRoleId: state.userInfos.role_id,
    transfersDetailsList: state.transfers.transfersDetailsList
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getTransfersDetails: payload => {
      dispatch(getTransfersDetails(payload));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TransfersDetails);



// WEBPACK FOOTER //
// src/modules/presence/transfers/transfersDetails/TransfersDetails.js